export default {"src":"/_next/static/media/scales-icon.6ce3d927.svg","height":44,"width":43};